import { render, staticRenderFns } from "./BetonList.vue?vue&type=template&id=79a30800&scoped=true&"
import script from "./BetonList.vue?vue&type=script&lang=js&"
export * from "./BetonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a30800",
  null
  
)

export default component.exports